module.exports = "export default __webpack_public_path__ + &quot;650158773486af61fb1deebf2a03f804.svg&quot;;"